import strings from '../../Localization/Localization';

import { index, getFromId, editFromId, newItem } from '../../API/Constructors';
import { form } from '../Form/constructors';
import { form as searchForm } from '../Form/Search/constructors';

import { constructors as routes } from '../Route/routes';

export const conf = {
  index: {
    pageTitle: strings.common.homepage.constructors,

    id: "constructor",
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_ADMIN'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => item.name
      },
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },
  },
  show: {
    pageTitle: strings.common.homepage.constructors,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "name",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.constructor.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (data) => {},

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_ADMIN'],
        editable: ['ROLE_ADMIN']
      },
    }
  },
  new: {
    pageTitle: strings.constructor.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (constructors) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
